export const DeviceModeConfModel = {
    id: "",
    name: "",
    model: "",
    interval_type: "con",
    values: {
        h_start: "10",
        min_measure: "60",
        num_pub: "6",
        num_measure: "1",
        min_measure_b: "2",
        interval_send: "1",
    },
};
export const DeviceSensors = {
    id: "",
    name: "",
    model: "",
    type: "s",
    has: {},
    sensors: {},
};

export const DeviceModel = {
    id: "",
    model_name: "",
    asset_name: "",
    group_name: "",
    created_at: "",
    updated_at: "",
    manufacturer_at: "",
    installed_at: "",
    end_at: "",
    last_comm_at: "",
    uuid: "",
    serial: "",
    reference: "",
    type: "s",
    status: "",
    displaying: false,
    lat: 0,
    lng: 0,
    notes: "",
    model: "",
    panel: "",
    asset: "",
    group: "",
    island: "",
};

export const ModelEmpty = {
    id: "",
    name: "",
    version: "",
    firmware: "",
    provider: "",
    manufacturer: "",
    type: "s",
    created_at: "",
    updated_at: "",
    description: "",
    notes: "",
};

export const AssetEmpty = {
    id: "",
    name: "",
    type: "",
    full_address: "",
    description: "",
    image: "",
    active: "",
};

export const DeviceModes = {

}

export const DevicesModels = {
    MODELS: {
        "MQ-0G-SX": {
            mode: "MQ-SX",
            product: "08",
            name: "Mini Q Sigfox GPS",
            network: "Sigfox",
            GPS: true,
            container: "miniq",
        },
        "MQ-00-SX": {
            mode: "MQ-SX",
            product: "08",
            name: "Mini Q Sigfox",
            network: "Sigfox",
            GPS: false,
            container: "miniq",
        },
        "MQ2-0G-4G-02US-WW": {
            mode: "MQ2-4G",
            product: "16",
            name: "Mini Q2 4G - 2U",
            network: "4G",
            GPS: true,
            container: "miniq2",
        },
        "QT-0G-2G": {
            mode: "QT-2G",
            name: "Q 2G GPS",
            network: "2G",
            GPS: true,
            container: "q-legacy",
        },
        "QT-00-2G": {
            mode: "QT-2G",
            name: "Q 2G",
            network: "2G",
            GPS: false,
            container: "q-legacy",
        },
    },
};
